module.exports = __webpack_public_path__ + "img/logo-bottom-text.07da88bb.png";